import React from "react";

import {ScrollReminder} from "../../scroll-reminder";
import {useScrollContext} from "../scroll-context";

/**
 * Display scroll reminder based on scroll state.
 */
export const ScrollPdfToBottomReminder = ({
  isLoadingPdf,
}: {
  isLoadingPdf: boolean;
}): JSX.Element | null => {
  const {scrollable, scrolledToBottomBefore, didScroll} = useScrollContext();

  return scrollable && !scrolledToBottomBefore && !isLoadingPdf ? (
    <ScrollReminder hidden={didScroll} hideTimeout={10000} />
  ) : null;
};
